<mat-slide-toggle
  [checked]="isChecked"
  (change)="handleToggle($event)"
></mat-slide-toggle>
